import { adminHttpClient } from '../../../commons/adminHttpClient'

const InitiateIchraRenewal = (): Promise<void> => {
  return adminHttpClient.post(`/Benefit/BenefitRenewal/Ichra/InitiateRenewal`, {})
}

export default InitiateIchraRenewal
